// here we add all base urls and keys

// Base URLS
// export const baseUrl = process.env.REACT_APP_DEV_BASE_URL;
export const baseUrl = process.env.REACT_APP_DEV_BASE_URL;
// export const baseUrl = process.env.REACT_APP_BASE_URL;
